import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './Home.css';
import unalLogo from '../gundogdudoviz1.png';

const Home = () => {
  return (
    <div className="home">
      <Helmet>
        <title>GÜNDOĞDU DÖVİZ VE ALTIN | Gaziemir B Grubu Yetkili Müessese</title>
        <meta name="description" content="GÜNDOĞDU DÖVİZ VE ALTIN YETKİLİ MÜESSESE A.Ş. Gaziemir, İzmir'de B Grubu yetkili müessese olarak döviz hizmetleri sunmaktadır." />
        <meta name="keywords" content="GÜNDOĞDU DÖVİZ VE ALTIN, döviz bürosu Gaziemir, İzmir döviz bürosu, B grubu döviz, sınırlı yetkili müessese" />
        <link rel="canonical" href="https://gundogdudoviz.com/" />
        <meta property="og:title" content="GÜNDOĞDU DÖVİZ VE ALTIN | Gaziemir B Grubu Yetkili Müessese" />
        <meta property="og:description" content="GÜNDOĞDU DÖVİZ VE ALTIN YETKİLİ MÜESSESE A.Ş. Gaziemir, İzmir'de hizmetinizde." />
        <meta property="og:url" content="https://gundogdudoviz.com/" />
        <meta property="og:type" content="website" />
      </Helmet>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-background">
          <div className="hero-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
          </div>
        </div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <div className="hero-badge">
                <span className="badge-icon">🏆</span>
                <span className="badge-text">40+ Yıl Güvenilir Hizmet</span>
              </div>
              <h1 className="hero-title">
                Türkiye'nin En Güvenilir
                <span className="gradient-text"> Döviz Bürosu</span>
              </h1>
              <p className="hero-description">
                Lisanslı ve profesyonel ekibimizle, tüm döviz işlemlerinizi 
                en uygun kurlarla, hızlı ve güvenli bir şekilde gerçekleştiriyoruz. 
                Müşteri memnuniyeti odaklı hizmet anlayışımızla yanınızdayız.
              </p>
              <div className="hero-stats">
                <div className="stat-item">
                  <div className="stat-number">15K+</div>
                  <div className="stat-label">Mutlu Müşteri</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">30+</div>
                  <div className="stat-label">Para Birimi</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">24/7</div>
                  <div className="stat-label">Destek Hattı</div>
                </div>
              </div>
              <div className="hero-buttons">
                <Link to="/iletisim" className="btn btn-primary">
                  <span className="btn-icon">📞</span>
                  İletişime Geç
                </Link>
                <Link to="/hakkimizda" className="btn btn-secondary">
                  <span className="btn-icon">ℹ️</span>
                  Hakkımızda
                </Link>
              </div>
              <div className="hero-trust">
                <div className="trust-badges">
                  <div className="trust-item">
                    <span className="trust-icon">🔒</span>
                    <span className="trust-text">SSL Güvenlik</span>
                  </div>
                  <div className="trust-item">
                    <span className="trust-icon">✅</span>
                    <span className="trust-text">Lisanslı Büro</span>
                  </div>
                  <div className="trust-item">
                    <span className="trust-icon">⚡</span>
                    <span className="trust-text">Anında İşlem</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="hero-visual">
              <div className="hero-illustration">
                <div className="floating-elements">
                  <div className="floating-card card-1">
                    <div className="card-icon">💰</div>
                    <div className="card-text">Güvenli İşlem</div>
                  </div>
                  <div className="floating-card card-2">
                    <div className="card-icon">🌍</div>
                    <div className="card-text">Global Hizmet</div>
                  </div>
                  <div className="floating-card card-3">
                    <div className="card-icon">⚡</div>
                    <div className="card-text">Hızlı Transfer</div>
                  </div>
                </div>
                <div className="main-visual">
                  <div className="visual-circle">
                    <div className="circle-content">
                      <div className="logo-large">
                        <img src={unalLogo} alt="GÜNDOĞDU DÖVİZ VE ALTIN" height={100} width={150} />
                      </div>
                      <div className="circle-text">GÜNDOĞDU DÖVİZ VE ALTIN</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services section-padding">
        <div className="container">
          <div className="section-header text-center">
            <h2 className="section-title">Hizmetlerimiz</h2>
            <p className="section-description">
              Müşterilerimize sunduğumuz kapsamlı döviz hizmetleri
            </p>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="service-card card">
                <div className="service-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="url(#serviceGradient1)"/>
                    <defs>
                      <linearGradient id="serviceGradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#667eea"/>
                        <stop offset="100%" stopColor="#764ba2"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <h3 className="service-title">Döviz Alım-Satım</h3>
                <p className="service-description">
                  Başlıca para birimlerinde avantajlı kurlar ve güvenilir hizmet 
                  anlayışıyla hızlı döviz alım-satım işlemleri sunuyoruz.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="service-card card">
                <div className="service-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8h16v10zm-10-7h2v2h2v2h-2v2h-2v-2H8v-2h2v-2z" fill="url(#serviceGradient2)"/>
                    <defs>
                      <linearGradient id="serviceGradient2" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#f093fb"/>
                        <stop offset="100%" stopColor="#f5576c"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <h3 className="service-title">Havale İşlemleri</h3>
                <p className="service-description">
                  Yurt içi para transferlerinizi hızlı, güvenli ve kolay bir şekilde 
                  gerçekleştirmenize yardımcı oluyoruz.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="service-card card">
                <div className="service-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                    <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z" fill="url(#serviceGradient3)"/>
                    <defs>
                      <linearGradient id="serviceGradient3" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#4facfe"/>
                        <stop offset="100%" stopColor="#00f2fe"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <h3 className="service-title">Altın İşlemleri</h3>
                <p className="service-description">
                  Çeyrek, yarım ve tam altın işlemlerinizde güncel piyasa koşullarına 
                  uygun, güvenilir alım-satım hizmeti sunuyoruz.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features section-padding">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="features-content">
                <h2 className="features-title">
                  Neden <span className="gradient-text">GÜNDOĞDU DÖVİZ VE ALTIN</span>?
                </h2>
                <p className="features-description">
                  Yılların deneyimi ve müşteri odaklı hizmet anlayışımızla 
                  döviz işlemlerinizde güvenilir partneriniziz.
                </p>
                <div className="features-list">
                  <div className="feature-item">
                    <div className="feature-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    <div className="feature-content">
                      <h4>Güvenilir Hizmet</h4>
                      <p>Lisanslı ve güvenilir döviz bürosu olarak hizmet veriyoruz.</p>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M13 10V3L4 14h7v7l9-11h-7z" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    <div className="feature-content">
                      <h4>Hızlı İşlem</h4>
                      <p>Tüm işlemlerinizi hızlı ve etkili bir şekilde gerçekleştiriyoruz.</p>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    <div className="feature-content">
                      <h4>Güvenli İşlem</h4>
                      <p>En yüksek güvenlik standartlarıyla işlemlerinizi koruyoruz.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="features-image">
                <div className="image-card">
                  <div className="stats-grid">
                    <div className="stat-item"> 
                      <div className="stat-number">40+</div>
                      <div className="stat-label">Yıl Deneyim</div>
                    </div>
                    <div className="stat-item">
                      <div className="stat-number">15K+</div>
                      <div className="stat-label">Mutlu Müşteri</div>
                    </div>
                    <div className="stat-item">
                      <div className="stat-number">30+</div>
                      <div className="stat-label">Para Birimi</div>
                    </div>
                    <div className="stat-item">
                      <div className="stat-number">24/7</div>
                      <div className="stat-label">Destek</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Branches Section */}
      <section className="branches section-padding">
        <div className="container">
          <div className="section-header text-center">
            <h2 className="section-title">Şubelerimiz</h2>
            <p className="section-description">
              Gaziemir'deki tek merkez şubemizle hizmetinizdeyiz
            </p>
          </div>
          <div className="branches-grid">
            {/* Merkez Şube */}
            <div className="branch-card main-branch">
              <div className="branch-content">
                <h3 className="branch-title">GÜNDOĞDU DÖVİZ VE ALTIN YETKİLİ MÜESSESE A.Ş.</h3>
                <div className="branch-info">
                  <div className="info-item">
                    <div className="info-icon">📍</div>
                    <div className="info-text">
                      <strong>Ataşehir Mahallesi, Anadolu Caddesi No: 977/A</strong><br />
                      Çiğli / İZMİR
                    </div>
                  </div>
                  <div className="info-item">
                    <div className="info-icon">📞</div>
                    <div className="info-text">
                      <strong>0 232 445 75 85</strong><br />
                      0 232 445 85 93
                    </div>
                  </div>
                </div>
                <div className="branch-map">
                  <iframe
                    src="https://www.google.com/maps?q=At%C4%B1fbey+Mahallesi+5+Sokak+No+90%2FB+Gaziemir+%C4%B0zmir&output=embed"
                    width="100%"
                    height="200"
                    style={{ border: 0, borderRadius: '12px' }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Merkez Şube Haritası"
                  ></iframe>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta section-padding">
        <div className="container">
          <div className="cta-content text-center">
            <h2 className="cta-title">Döviz İşlemleriniz İçin Bize Ulaşın</h2>
            <p className="cta-description">
              Profesyonel ekibimiz size en iyi hizmeti sunmak için hazır. 
              Hemen iletişime geçin ve avantajlı kurlardan yararlanın.
            </p>
            <div className="cta-buttons">
              <Link to="/iletisim" className="btn btn-primary">
                İletişime Geç
              </Link>
              <a href="tel:+902322525390" className="btn btn-secondary">
                Hemen Ara
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;